import { apiClient } from './client';
import type { IntegrationStatus } from '../types';

export const integrationsApi = {
  async list(): Promise<IntegrationStatus[]> {
    const { data } = await apiClient.get<{ integrations: IntegrationStatus[] }>('/integrations');
    return data.integrations;
  },
};
